import * as React from "react"

import * as S from "./styled"

const CardAbout = props => (
  <S.Card className={props.className}>{props.children}</S.Card>
)

export default CardAbout
